import React from 'react';

const Divider = () => {
  return (
    <hr style={{marginTop: "60px", marginBottom: "0px"}} />
  )
}

export default Divider;